export const projects = {
  en: [
  // iOS Apps
  {
    id: 1,
    title: "TAB",
    category: "iOS Application",
    year: "2024",
    img: "/projects/tab.png",
    details: {
        mission: "Track IOUs, split expenses, and remember who owes what—privately and effortlessly. Speak it, save it, and stay organized.",
        execution: "Voice input for fast entries. No accounts required. Data stored locally on device. Clean, distraction-free design.",
        status: "v1.0 // WAITING FOR REVIEW"
    }
  },
  {
    id: 2,
    title: "HARVEST",
    category: "iOS Application",
    year: "2024",
    img: "/projects/harvest.png",
    details: {
        mission: "Connect neighbors to fresh food. Buy, sell, and share locally grown produce through simple listings and secure messaging.",
        execution: "Location-based discovery. Integrated chat. No middlemen. Support for small growers and home gardeners.",
        status: "v1.0 // WAITING FOR REVIEW"
    }
  },
  {
    id: 3,
    title: "COMANDO",
    category: "iOS Application",
    year: "2024",
    img: "/projects/comando.png",
    details: {
        mission: "A fully offline, on-device AI assistant for secure reference, procedures, and guidance in low-connectivity environments.",
        execution: "Local RAG system. 100% Offline. No data collection. Optimized for speed and low power usage.",
        status: "v1.3 // READY FOR DISTRIBUTION"
    }
  },
  // Web Projects
  {
    id: 4,
    title: "5 PANES 2 PECES",
    category: "Web Platform",
    year: "2024",
    img: "https://images.unsplash.com/photo-1438232992991-995b7058bbb3?q=80&w=800&auto=format&fit=crop", // Church/Faith abstract
    details: {
        mission: "A digital sanctuary for community, faith, and outreach. Connecting people through shared values and modern web experiences.",
        execution: "Modern web architecture for event scheduling, resources, and community engagement.",
        status: "LIVE // 5panes2peces.org"
    },
    link: "https://www.5panes2peces.org/"
  },
  {
    id: 5,
    title: "NEW HOPE",
    category: "Web Platform",
    year: "2024",
    img: "https://images.unsplash.com/photo-1499209974431-9dddcece7f88?q=80&w=800&auto=format&fit=crop", // Nature/Hope abstract
    details: {
        mission: "Bringing hope to life through a digital platform for connection, spiritual growth, and community support.",
        execution: "Seamless user experience for streaming services, group signups, and multimedia resources.",
        status: "LIVE // newhope.life"
    },
    link: "https://newhope.life"
  },
  {
    id: 6,
    title: "DALEY WED",
    category: "Web Platform",
    year: "2024",
    img: "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?q=80&w=800&auto=format&fit=crop", // Wedding/Elegant abstract
    details: {
        mission: "Capturing timeless moments. A premium digital portfolio and booking platform for wedding services.",
        execution: "High-resolution image delivery, elegant client galleries, and streamlined booking inquiry system.",
        status: "LIVE // daleywed.com"
    },
    link: "https://daleywed.com"
  }
  ],
  es: [
  // iOS Apps
  {
    id: 1,
    title: "TAB",
    category: "Aplicación iOS",
    year: "2024",
    img: "/projects/tab.png",
    details: {
        mission: "Rastrea deudas, divide gastos y recuerda quién debe qué—privada y fácilmente. Háblalo, guárdalo y mantente organizado.",
        execution: "Entrada de voz para registros rápidos. Sin cuentas. Datos almacenados localmente. Diseño limpio y sin distracciones.",
        status: "v1.0 // ESPERANDO REVISIÓN"
    }
  },
  {
    id: 2,
    title: "HARVEST",
    category: "Aplicación iOS",
    year: "2024",
    img: "/projects/harvest.png",
    details: {
        mission: "Conecta vecinos con comida fresca. Compra, vende y comparte productos locales mediante listados simples y mensajería segura.",
        execution: "Descubrimiento basado en ubicación. Chat integrado. Sin intermediarios. Apoyo a pequeños agricultores y jardineros caseros.",
        status: "v1.0 // ESPERANDO REVISIÓN"
    }
  },
  {
    id: 3,
    title: "COMANDO",
    category: "Aplicación iOS",
    year: "2024",
    img: "/projects/comando.png",
    details: {
        mission: "Un asistente de IA totalmente offline para referencia segura, procedimientos y orientación en entornos de baja conectividad.",
        execution: "Sistema RAG local. 100% Offline. Sin recolección de datos. Optimizado para velocidad y bajo consumo.",
        status: "v1.3 // LISTO PARA DISTRIBUCIÓN"
    }
  },
  // Web Projects
  {
    id: 4,
    title: "5 PANES 2 PECES",
    category: "Plataforma Web",
    year: "2024",
    img: "https://images.unsplash.com/photo-1438232992991-995b7058bbb3?q=80&w=800&auto=format&fit=crop", // Church/Faith abstract
    details: {
        mission: "Un santuario digital para la comunidad, fe y alcance. Conectando a las personas a través de valores compartidos y experiencias web modernas.",
        execution: "Arquitectura web moderna para programación de eventos, recursos y participación comunitaria.",
        status: "EN VIVO // 5panes2peces.org"
    },
    link: "https://www.5panes2peces.org/"
  },
  {
    id: 5,
    title: "NEW HOPE",
    category: "Plataforma Web",
    year: "2024",
    img: "https://images.unsplash.com/photo-1499209974431-9dddcece7f88?q=80&w=800&auto=format&fit=crop", // Nature/Hope abstract
    details: {
        mission: "Dando vida a la esperanza a través de una plataforma digital para la conexión, el crecimiento espiritual y el apoyo comunitario.",
        execution: "Experiencia de usuario perfecta para servicios de transmisión, inscripciones en grupos y recursos multimedia.",
        status: "EN VIVO // newhope.life"
    },
    link: "https://newhope.life"
  },
  {
    id: 6,
    title: "DALEY WED",
    category: "Plataforma Web",
    year: "2024",
    img: "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?q=80&w=800&auto=format&fit=crop", // Wedding/Elegant abstract
    details: {
        mission: "Capturando momentos inolvidables. Un portafolio digital premium y plataforma de reservas para servicios de bodas.",
        execution: "Entrega de imágenes en alta resolución, galerías elegantes para clientes y un sistema de consulta de reservas optimizado.",
        status: "EN VIVO // daleywed.com"
    },
    link: "https://daleywed.com"
  }
  ]
};
